/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import has from"../../../../../core/has.js";function e(){return!!has("enable-feature:objectAndLayerId-rendering")}export{e as olidEnabled};
